import { Menu as BaseMenu } from '@calendly/ui/components/menu';
import { SelectUI } from '@calendly/ui/components/select';
import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const markerIsNotAvailableCss = "mm2ibfm";
const markerCss = "m1qi5qpm";
const Marker = forwardRef((props, ref) => {
  const {
    isNotAvailable,
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = props.isNotAvailable ? null : {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(markerCss, {
    [markerIsNotAvailableCss]: isNotAvailable
  }, props.className)} />;
});
const notAvailableCss = "n26wafq";
export const NotAvailable = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(notAvailableCss, props.className)} />;
});
const containerIsPhoneCss = "c1flhewt";
const containerCss = "ccp40go";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const wideMarkerCss = "w1ca6u70";
export const WideMarker = forwardRef((props, ref) => <Marker ref={ref} {...props} className={classNames(wideMarkerCss, props.className)} />);
const optionsCss = "o76ax65";
export const Options = forwardRef((props, ref) => <BaseMenu ref={ref} {...props} className={classNames(optionsCss, props.className)} />);
const selectionControlsContainerCss = "s195f9fx";
export const SelectionControlsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(selectionControlsContainerCss, props.className)} />;
});
const placeholderCss = "p1c2sy55";
export const Placeholder = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(placeholderCss, props.className)} />;
});
const UnstyledMenuActionItem = ({
  ...restProps
}) => <li><div {...restProps} /></li>;
const menuActionItemCss = "m19o3hk3";
export const MenuActionItem = forwardRef((props, ref) => <UnstyledMenuActionItem ref={ref} {...props} className={classNames(menuActionItemCss, props.className)} />);
const groupHeaderCss = "gh3gxtu";
export const GroupHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(groupHeaderCss, props.className)} />;
});
const eventTypeCheckboxFieldIsDeletedCss = "e11069kv";
const eventTypeCheckboxFieldCss = "edxj1fm";
export const EventTypeCheckboxField = forwardRef((props, ref) => {
  const {
    isDeleted
  } = props;
  return <CheckboxField ref={ref} {...props} className={classNames(eventTypeCheckboxFieldCss, {
    [eventTypeCheckboxFieldIsDeletedCss]: isDeleted
  }, props.className)} />;
});
const menuContainerCss = "m10p6ke3";
export const MenuContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuContainerCss, props.className)} />;
});
const listCss = "lexyvxq";
export const List = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} data-component="menu-container" className={classNames(listCss, props.className)} />;
});
const styledSelectUIIsWideCss = "s1lw1q5h";
const styledSelectUICss = "s1cumtuc";
export const StyledSelectUI = forwardRef((props, ref) => {
  const {
    isWide,
    ...restProps
  } = props;
  return <SelectUI ref={ref} {...restProps} className={classNames(styledSelectUICss, {
    [styledSelectUIIsWideCss]: isWide
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");